import styled from 'styled-components';
// import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';

const customMedia = generateMedia({
  mobile: "320px",
  tablet: "767px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

export const ContainerMenu = styled.div`
  display: none;
  padding: calc(var(--space) * 1.3) 1.5em;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  ${customMedia.lessThan('tablet')`
    
    &.active {
      display: flex; 
      width: 100vw;
      padding: 2vh;   
    }
  `}
  
  ${customMedia.greaterThan('tablet')`
    display: flex;
    padding: calc(var(--space) * 1.3) 3rem;
  `}

  ${customMedia.greaterThan('laptop')`
    padding: calc(var(--space) * 1.3) 6rem;
  `}

  ${customMedia.greaterThan('laptopL')`
    padding: calc(var(--space) * 1.3) 8rem;    
  `}

  ${customMedia.greaterThan('laptopXL')`
    padding: calc(var(--space) * 1.3) 10rem;    
  `}
`;
  
  
  
  
  
  
  
  